import { noop } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { $rqCustomizationApiClient } from "@/api/customization"
import { query } from "@/api/query"
import { MY_SPACE } from "@/constants/spaces"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/branding/")({
  beforeLoad: async ({ context }) => {
    // Custom Branding is visible only to roles with customization::read (PRO Admin/Editor).
    await routeGuard(context, { allowPrivateSpace: false, permission: { flag: "local::branding::view" } })

    const spaces = await context.queryClient.query({ ...query.space.list, staleTime: "static" })
    const space = spaces.find(sp => sp.id === context.spaceStorage.getSpace()) || MY_SPACE

    // If the space is not an enterprise space, redirect to root
    if (space.space !== "pro") {
      redirect({
        to: "/",
        throw: true
      })
    }
  },

  loader: ({ context: { queryClient, spaceStorage } }) => {
    const space = spaceStorage.getSpace()

    queryClient
      .query(
        $rqCustomizationApiClient.queryOptions("get", "/v1/customizable/ofOrg/{organization_id}", {
          params: { path: { organization_id: space } }
        })
      )
      .catch(noop)
  },
  head: () => ({
    meta: [
      {
        title: "Branding | Arduino Cloud"
      }
    ]
  })
})
